export default __webpack_public_path__ + "static/media/Slide_SaleKit2024-07.781b4aa8.png";